export default "__VITE_ASSET__DuV6_8HP__"